import * as BaseAPI from '@/api/baseAPI';
import JobStatus from "../../../shared/models/jobStatus";

export async function getJobStatuses(): Promise<JobStatus[]> {
  const result = await BaseAPI.simpleGet(`/jobstatuses`);
  return result.data;
}